export default "__VITE_ASSET__i9VTmUwP__"